var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"d-flex justify-center"},[_c('v-col',{staticClass:"pr-3 text-center mt-9",attrs:{"cols":"auto"}},[_c('QuotationStatusMessage',{attrs:{"title":_vm.message,"text":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }